import React, { useEffect, useState } from "react";
import propTypes from "prop-types";
import { compose } from "recompose";
import { withSnackbar } from "notistack";

import { Button } from "@material-ui/core";
import { Marker, Popup } from "react-leaflet";
import { DivIcon } from "../../../../components";

import { baseIcon, IconImb, IconPavillon, IconAt } from "../icons";
import { colorIcons } from "../../../../enums";

import { Immeuble } from "../../../../services";
import { setLogoFromDsp } from "../../../../utils";

const MarkersImbFtthVN = ({
  dsp,
  imbWkt,
  optionSelectedConfigCarte,
  displayMarkerImb,
  setChargementIMBWtk,
  onMarkerImbClick,
  onOperatorPopupClick,
  enqueueSnackbar,
}) => {
  const [markersImmeubles, setMarkersImmeubles] = useState([]);
  const [abortImbWkt, setAbortImbWkt] = useState(new AbortController());

  /*
    STATUT IMMEUBLE                     | CODE STATUT
                                        |
    RA : Raccordé                       | RA : Raccordé
    DE : Déployé && MeS < today         | EL : Eligible
    GE : Déployé && MeS > today         | PE : Prochainement Eligible
    CI : Ciblé                          | RD : Raccordable sur demande
    SI : Signé                          | TRR : Travaux dans votre rue
    EC : En cours de déploiement        | TRS : Travaux dans votre secteur
    TRR : Travaux dans votre rue        | ET : En cours d'étude
    TRS : Travaux dans votre secteur    |
    RD : Raccordable sur demande        |
    ET : En cours d'étude               |
  */

  // Récupère les immeubles pour une zone géographique
  const getImmeublesWTK = async (minLatLng, maxLatLng) => {
    setChargementIMBWtk(true);

    abortImbWkt.abort();
    const abort = new AbortController();
    setAbortImbWkt(abort);

    Immeuble.getImmeublesVendeeFtthWkt(
      minLatLng.lng,
      minLatLng.lat,
      maxLatLng.lng,
      maxLatLng.lat,
      abort,
    )
      .then(responseImbsFtth => {
        const markersImmeublesTemp = responseImbsFtth.features
          .filter(
            imb =>
              imb.properties.codeReseau === dsp.codeReseau &&
              imb.properties.statutEligibilite !== "AB",
          )
          .map(item => {
            const itemProps = { ...item.properties };
            let statutElig = "";
            let codeStatut = "";
            let color = "";

            if (itemProps.gelCommercial === "1") {
              statutElig = "Gel Commercial / cliquer pour plus de  détails";
              codeStatut = "PE";
              color = colorIcons.gelVendee;
            } else if (itemProps.statutEligibilite === "RA") {
              statutElig = "Déployé";
              codeStatut = "RA";
              color = colorIcons.raccorde;
            } else if (itemProps.statutEligibilite === "DE") {
              statutElig = "Déployé";
              codeStatut = "EL";
              color = colorIcons.deploye;
            } else if (itemProps.statutEligibilite === "GE") {
              statutElig = "Déployé";
              codeStatut = "PE";
              color = colorIcons.gelVendee;
            } else if (itemProps.statutEligibilite === "EC") {
              if (itemProps.statutSRO === "DEPLOYE" && itemProps.NB_IMBPBO > 0) {
                statutElig = "Travaux en cours dans votre rue";
                codeStatut = "TRR";
                color = colorIcons.travauxRueVendee;
              } else if (itemProps.statutSRO === "DEPLOYE") {
                statutElig = "Travaux en cours dans votre secteur";
                itemProps.statutEligibilite = "TRS";
                codeStatut = "TRS";
                color = colorIcons.travauxSecteurVendee;
              } else {
                // Fallback
                statutElig = "En cours d'étude";
                itemProps.statutEligibilite = "ET";
                codeStatut = "ET";
                color = colorIcons.cibleVendee;
              }
            } else if (itemProps.statutEligibilite === "RD") {
              statutElig = "Raccordable sur demande";
              codeStatut = "RD";
              color = colorIcons.demandeVendee;
            } else {
              // Case SI / CI / ET
              statutElig = "En cours d'étude";
              codeStatut = "ET";
              color = colorIcons.cibleVendee;
            }

            const marker = {
              key: itemProps.referenceIMB,
              position: [item.geometry.coordinates[1], item.geometry.coordinates[0]],
              icon: getIconTypeStatut(itemProps, color),
              codeStatut: codeStatut,
              technoIMB: itemProps.technoIMB,
              referenceIMB: itemProps.referenceIMB,
              statutElig: statutElig,
              nomBatiment: itemProps.nomBatiment,
              numeroAdresse: `${itemProps.numeroAdresse}${itemProps.extensionAdresse}`,
              voieAdresse: itemProps.voieAdresse,
              codePostal: itemProps.codePostal,
              libelleCommune: itemProps.libelleCommune,
              codeReseau: itemProps.codeReseau,
            };

            return marker;
          });

        setMarkersImmeubles(markersImmeublesTemp);
        setChargementIMBWtk(false);
      })
      .catch(e => {
        if (e.code !== "ERR_CANCELED") {
          setChargementIMBWtk(false);
          enqueueSnackbar(process.env.ERREUR_SERVEUR, {
            variant: "error",
            autoHideDuration: 6000,
          });
        }
      });
  };

  // Récupère l'icône de statut de l'immeuble
  const getIconTypeStatut = (marker, color) => {
    const { gelCommercial, statutEligibilite, typeIMB } = marker;
    let icon = "";

    if (gelCommercial === "1") icon = typeIMB === "P" ? IconPavillon : IconImb;
    else if (statutEligibilite === "RA") icon = IconAt;
    else if (typeIMB === "P") icon = IconPavillon;
    else icon = IconImb;

    return new DivIcon({
      html: icon,
      className: `ai-icon`,
      style: {
        color: color,
        fontSize: "0.8em",
      },
      ...baseIcon,
    });
  };

  useEffect(() => {
    if (displayMarkerImb && imbWkt.minLatLng && imbWkt.maxLatLng) {
      getImmeublesWTK(imbWkt.minLatLng, imbWkt.maxLatLng);
    }
  }, [imbWkt]);

  useEffect(() => () => abortImbWkt.abort(), []);

  return (
    <>
      {displayMarkerImb &&
        markersImmeubles.length > 0 &&
        markersImmeubles
          .filter(
            marker =>
              (optionSelectedConfigCarte.IMB_RAC && marker.codeStatut === "RA") ||
              (optionSelectedConfigCarte.IMB_ELIG && marker.codeStatut === "EL") ||
              (optionSelectedConfigCarte.IMB_PROELIG && marker.codeStatut === "PE") ||
              (optionSelectedConfigCarte.IMB_TRAVAUX_RUE && marker.codeStatut === "TRR") ||
              (optionSelectedConfigCarte.IMB_TRAVAUX_SECTEUR && marker.codeStatut === "TRS") ||
              (optionSelectedConfigCarte.IMB_ETUDE && marker.codeStatut === "ET") ||
              (optionSelectedConfigCarte.IMB_DEMANDE && marker.codeStatut === "RD"),
          )
          .map(marker => (
            <Marker
              key={marker.key}
              position={marker.position}
              icon={marker.icon}
              codeStatut={marker.codeStatut}
              technoIMB={marker.technoIMB}
              statutElig={marker.statutElig}
              riseOnHover
            >
              <Popup maxWidth={260} autoPan={false}>
                <div className="alignRight">{setLogoFromDsp(dsp)}</div>
                <br />
                <div className="popupTitle popupTitleColor">{marker.referenceIMB}</div>
                {marker.nomBatiment && <div>{marker.nomBatiment}</div>}
                <div>
                  {marker.numeroAdresse} {marker.voieAdresse}, {marker.codePostal}{" "}
                  {marker.libelleCommune}
                </div>
                <br />
                <div>Eligibilité : {marker.statutElig}</div>
                <div>Technologie : {marker.technoIMB}</div>
                <br />
                {(marker.codeStatut === "EL" ||
                  marker.codeStatut === "PE" ||
                  marker.codeStatut === "RD") && (
                  <>
                    <p className="popupTextContainer alignJustify">
                      Votre logement est éligible à une offre fibre. Contactez un fournisseur{" "}
                      d&apos;accès partenaire de Vendée Numérique.{" "}
                    </p>
                    <div className="buttonContainer">
                      <Button
                        className="markerButtonFai"
                        onClick={() =>
                          onOperatorPopupClick({
                            nomBatiment: marker.nomBatiment,
                            numeroAdresse: marker.numeroAdresse,
                            voieAdresse: marker.voieAdresse,
                            codePostal: marker.codePostal,
                            libelleCommune: marker.libelleCommune,
                            imb: marker.key,
                            latitude: marker.position[0],
                            longitude: marker.position[1],
                            resultat: marker.statutElig,
                            codeReseau: marker.codeReseau,
                          })
                        }
                      >
                        Je souhaite être contacté
                      </Button>
                    </div>
                  </>
                )}
                {marker.codeStatut === "RD" && (
                  <div>
                    Votre logement a été identifié comme raccordable à la demande. Par conséquent,
                    si vous souhaitez être raccordé au réseau fibre FttH de Vendée Numérique,
                    <a
                      href="https://www.vendeenumerique.fr/raccordement-a-la-demande"
                      rel="noreferrer"
                      target="_blank"
                    >
                      cliquez ici pour obtenir des informations complémentaires.
                    </a>
                  </div>
                )}
                <div className="alignCenter">
                  <Button
                    className="markerButtonDetail"
                    onClick={() => onMarkerImbClick(marker.key, marker.position, marker.technoIMB)}
                  >
                    Plus de détails
                  </Button>
                </div>
              </Popup>
            </Marker>
          ))}
    </>
  );
};

MarkersImbFtthVN.propTypes = {
  dsp: propTypes.shape({
    logo: propTypes.string,
    codeMarche: propTypes.string,
    codeReseau: propTypes.string,
    libelle: propTypes.string,
    urlSite: propTypes.string,
    urlZonesDeploiement: propTypes.string,
    urlFibreFtth: propTypes.string,
    urlFibreSurDemande: propTypes.string,
    urlFibreFtte: propTypes.string,
    urlChangementAdresse: propTypes.string,
    urlListeOperateur: propTypes.string,
    urlPreparation: propTypes.string,
  }).isRequired,
  imbWkt: propTypes.shape({
    minLatLng: propTypes.shape({
      lat: propTypes.number,
      lng: propTypes.number,
    }),
    maxLatLng: propTypes.shape({
      lat: propTypes.number,
      lng: propTypes.number,
    }),
  }).isRequired,
  optionSelectedConfigCarte: propTypes.shape({
    LAYER_PLAN: propTypes.bool,
    LAYER_SAT: propTypes.bool,
    ALL_ZONES: propTypes.bool,
    SRO_DEP_201820: propTypes.bool,
    SRO_DEP_2021: propTypes.bool,
    SRO_DEP_2022: propTypes.bool,
    SRO_DEP_2023: propTypes.bool,
    SRO_OPEN: propTypes.bool,
    SRO_SOON: propTypes.bool,
    SRO_YEAR_N0: propTypes.bool,
    SRO_YEAR_N1: propTypes.bool,
    SRO_YEAR_N2: propTypes.bool,
    ZONE_RADIO: propTypes.bool,
    ZONE_AMII: propTypes.bool,
    ALL_STATUSES: propTypes.bool,
    IMB_RAC: propTypes.bool,
    IMB_ELIG: propTypes.bool,
    IMB_PROELIG: propTypes.bool,
    IMB_ETUDE: propTypes.bool,
    IMB_TRAVAUX_SECTEUR: propTypes.bool,
    IMB_TRAVAUX_RUE: propTypes.bool,
    IMB_DEMANDE: propTypes.bool,
    FTTE: propTypes.bool,
  }).isRequired,
  displayMarkerImb: propTypes.bool.isRequired,
  setChargementIMBWtk: propTypes.func.isRequired,
  onMarkerImbClick: propTypes.func.isRequired,
  onOperatorPopupClick: propTypes.func.isRequired,
  enqueueSnackbar: propTypes.func.isRequired,
};

export default compose(withSnackbar)(MarkersImbFtthVN);
